import { render, staticRenderFns } from "./DocumentCptCodesTabContent.vue?vue&type=template&id=42307f7d&scoped=true&"
import script from "./DocumentCptCodesTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentCptCodesTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCptCodesTabContent.vue?vue&type=style&index=0&id=42307f7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42307f7d",
  null
  
)

export default component.exports